import { number } from "prop-types";
import React from "react";



import styled from "styled-components/macro";



import FnrIcon from "UI/FnrIcon";



import ExpandableStat from "./ExpandableStat";


export const STAT = {
  PERCENT_PLEDGED: "percentPledged",
  PLEDGES_FULFILLED: "pledgesFulfilled",
  PLEDGES_WITH_RECURRING_GIFT: "pledgesWithRecurringGift",
};

function Stats({
  percentOfHouseholdsPledged,
  pledgesCount,
  pledgesFulfilledCount,
  pledgesWithRecurringGiftCount,
}) {
  const [selectedStat, setSelectedStat] = React.useState(null);
  const percentPledged = `${Math.round(percentOfHouseholdsPledged * 100)}%`;

  return (
    <Wrapper
      onClick={(e) => {
        e.stopPropagation();
        setSelectedStat(null)
      }}
    >
      <ExpandableStat
        icon="fa-badge-percent far"
        staticText={percentPledged}
        expandableText="of households pledged"
        selected={selectedStat === STAT.PERCENT_PLEDGED}
        setSelectedStat={setSelectedStat}
        stat={STAT.PERCENT_PLEDGED}
      />
      <ExpandableStat
        icon="fa-badge-check far"
        staticText={`${pledgesFulfilledCount} of ${pledgesCount}`}
        expandableText="pledges fulfilled"
        selected={selectedStat === STAT.PLEDGES_FULFILLED}
        setSelectedStat={setSelectedStat}
        stat={STAT.PLEDGES_FULFILLED}
      />
      <ExpandableStat
        icon="fa-badge-dollar far"
        staticText={`${pledgesWithRecurringGiftCount}`}
        expandableText={pledgesWithRecurringGiftCount === 1 ? "pledge has a recurring gift" : "pledges have recurring gifts"}
        selected={selectedStat === STAT.PLEDGES_WITH_RECURRING_GIFT}
        setSelectedStat={setSelectedStat}
        stat={STAT.PLEDGES_WITH_RECURRING_GIFT}
      />
    </Wrapper>
  );
}

export default Stats;

Stats.propTypes = {
  percentOfHouseholdsPledged: number,
  pledgesCount: number,
  pledgesFulfilledCount: number,
  pledgesWithRecurringGiftCount: number,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-block-start: 0.25rem;
  cursor: default;

  @container campaign (width < 470px) {
    display: none;
  }
`;